// extracted by mini-css-extract-plugin
export var text = "_bi-0";